

// --- WebGL ---

const threeDDomainDev = 'https://three-dev.inffur.com/'
const threeDDomainTest = 'https://three.inffur.com/'
const threeDDomainRelease = 'https://3d-temp.inffur.com/'
const threeDDomainPro = 'https://three-prod.inffur.com/'

const threeDDomainRelease_new = 'https://3d.mofanghouse.com/'    //  3d新 生产 环境
const threeDDomainTest_new = 'https://3d-test.mofanghouse.com/'  //  3d新 测试 环境

const customize_3d_test_ = 'https://3d-test-design.mofanghouse.com/'  //  3d 定制柜 测试 环境 (弃用)
const customize_3d_release_ = 'https://3d-design.mofanghouse.com/'  //  3d 定制柜 生产 环境 (弃用)

const customize_3d_test = 'https://3d-test.yidaocube.com/' //  h5 定制柜 测试 环境
const customize_3d_release = 'https://3d.yidaocube.com/' //  h5 定制柜 生产 环境

export const threeDDomain = customize_3d_release


// --- New WebGL ---

const customize_webgl_test = 'https://webgl-test.yidaocube.com/' //  新3d 定制柜 测试 环境
const customize_webgl_release = 'https://webgl.yidaocube.com/' //  新3d 定制柜 生产 环境

export const WebglDomain = customize_webgl_release


// --- H5 ---

const appDomainTest = 'https://myhome-test.inffur.com/'
const appDomainRelease = 'https://h5-temp.inffur.com/'
const appDomainPro = 'https://myhome-pro.inffur.com/'

const appDomainRelease_new = 'https://h5.mofanghouse.com/'      //  h5新 生产 环境
const appDomainTest_new = 'https://h5-test.mofanghouse.com/'    //  h5新 测试 环境

const customize_h5_test_ = 'https://h5-test-design.mofanghouse.com/' //  h5 定制柜 测试 环境 (弃用)
const customize_h5_release_ = 'https://h5-design.mofanghouse.com/' //  h5 定制柜 生产 环境 (弃用)

const customize_h5_test = 'https://h5-test.yidaocube.com/' //  h5 定制柜 测试 环境
const customize_h5_release = 'https://h5.yidaocube.com/' //  h5 定制柜 生产 环境

export const appDomain = customize_h5_release


// --- API ---

const domainDev = 'https://api.inffur.com/api/'
const domainTest = 'https://test.inffur.com/api/'
const domainRelease = 'https://api-temp.inffur.com/api/'
const domainPro = 'https://api-prod.inffur.com/api/'

const domainRelease_new = 'https://api.mofanghouse.com/api'     // API新 生产 环境
const domainTest_new = 'https://api-test.mofanghouse.com/api'   // API新 测试 环境

const customize_api_test_ = 'https://api-test-design.mofanghouse.com/api'   // API 定制柜 测试 环境 (弃用)
const customize_api_release_ = 'https://api-design.mofanghouse.com/api'   // API 定制柜 测试 环境 (弃用)

const customize_api_test = 'https://api-test.yidaocube.com/api' //  h5 定制柜 测试 环境
const customize_api_release = 'https://api.yidaocube.com/api' //  h5 定制柜 生产 环境

export const domain = customize_api_release

export const imgDomain = 'https://cdn.inffur.com/'
